module.exports = __webpack_public_path__ + "img/group_x_login.eac3bca5.png";